export default __webpack_public_path__ + "static/media/Restraunt.d4298736.jpg";